var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushPinOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 2.66667V6C9.33331 6.74667 9.57998 7.44 9.99998 8H5.99998C6.43331 7.42667 6.66665 6.73334 6.66665 6V2.66667H9.33331ZM11.3333 1.33334H4.66665C4.29998 1.33334 3.99998 1.63334 3.99998 2C3.99998 2.36667 4.29998 2.66667 4.66665 2.66667H5.33331V6C5.33331 7.10667 4.43998 8 3.33331 8V9.33334H7.31331V14L7.97998 14.6667L8.64665 14V9.33334H12.6666V8C11.56 8 10.6666 7.10667 10.6666 6V2.66667H11.3333C11.7 2.66667 12 2.36667 12 2C12 1.63334 11.7 1.33334 11.3333 1.33334Z",
    fill: "#6D6E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushPinOutlined);
export default __webpack_public_path__ + "static/media/push_pin_outlined.b8ebda38a6a8a0b42a32c426920c76df.svg";
export { ForwardRef as ReactComponent };